import { Link } from 'react-router-dom';

export default function Gallery() {
  const portfolioItems = [
    {
      id: 1,
      title: 'Foto Produk',
      description: 'Hasil foto produk profesional untuk UMKM',
      image: 'https://public.readdy.ai/ai/img_res/d2c7856898ebc30940b7e69b1bdc7b0b.jpg',
      category: 'photography'
    },
    {
      id: 2,
      title: 'Desain Banner',
      description: 'Banner promosi untuk event dan bisnis',
      image: 'https://readdy.ai/api/search-image?query=modern%20colorful%20promotional%20banner%20design%20mockup%20displayed%20on%20outdoor%20billboard%20with%20vibrant%20graphics%20and%20clean%20typography%20professional%20advertising%20design&width=600&height=400&seq=gallery2&orientation=landscape',
      category: 'design'
    },
    {
      id: 3,
      title: 'Instalasi CCTV',
      description: 'Pemasangan sistem keamanan CCTV',
      image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20installation%20on%20building%20exterior%20with%20multiple%20cctv%20cameras%20mounted%20professionally%20clean%20white%20background%20professional%20security%20system&width=600&height=400&seq=gallery3&orientation=landscape',
      category: 'installation'
    },
    {
      id: 4,
      title: 'Undangan Digital',
      description: 'Desain undangan pernikahan digital elegan',
      image: 'https://readdy.ai/api/search-image?query=elegant%20digital%20wedding%20invitation%20design%20displayed%20on%20smartphone%20screen%20with%20beautiful%20floral%20decorations%20and%20modern%20typography%20romantic%20theme%20with%20soft%20colors&width=600&height=400&seq=gallery4&orientation=landscape',
      category: 'design'
    },
    {
      id: 5,
      title: 'Servis Laptop',
      description: 'Perbaikan dan maintenance laptop',
      image: 'https://readdy.ai/api/search-image?query=laptop%20repair%20service%20workstation%20with%20technician%20tools%20and%20opened%20laptop%20being%20serviced%20clean%20white%20background%20professional%20technical%20service&width=600&height=400&seq=gallery5&orientation=landscape',
      category: 'service'
    },
    {
      id: 6,
      title: 'LED Display',
      description: 'Instalasi LED display untuk bisnis',
      image: 'https://readdy.ai/api/search-image?query=modern%20led%20display%20screen%20installation%20showing%20bright%20colorful%20content%20mounted%20on%20clean%20white%20wall%20professional%20digital%20signage%20system&width=600&height=400&seq=gallery6&orientation=landscape',
      category: 'installation'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Galeri <span className="text-[#FF8A00]">Hasil Kerja</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Lihat berbagai hasil pekerjaan kami yang telah dipercaya oleh ratusan pelanggan
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {portfolioItems.map((item) => (
            <Link
              key={item.id}
              to="/portofolio"
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3B] via-[#0B1F3B]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white font-bold text-xl mb-2">{item.title}</h3>
                  <p className="text-gray-200 text-sm">{item.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Link
            to="/portofolio"
            className="inline-flex items-center gap-3 bg-[#FF8A00] hover:bg-[#e67d00] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Lihat Semua Portofolio
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
